import styled from 'styled-components';
import { body1, colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  p75: pxToRem(75),
  p125: pxToRem(125),
  p177: pxToRem(177),
  p310: pxToRem(310),
  p490: pxToRem(490),
};

export const SubTitleLink = styled.a`
  ${body1};
  color: ${colors.textLink};
`;

export const StyledSelectControlWrapper = styled.div`
  > [role='radiogroup'] {
    line-height: ${spacing.threeQuarter};
  }
`;

export const ListWrapper = styled.div`
  padding: 0 ${spacing.plusHalf};
  width: 100%;
  & > div:not(:last-child) {
    border-bottom: ${spacing.single} solid ${colors.grey5};
  }
`;

export const ListRowWrapper = styled.div`
  display: grid;
  grid-template-columns:
    minmax(${customSpacing.p125}, 0.5fr)
    minmax(${customSpacing.p75}, 0.5fr)
    minmax(${customSpacing.p490}, 5fr)
    minmax(${customSpacing.p310}, 3fr)
    minmax(${customSpacing.p177}, 1.5fr);
  padding: ${spacing.plusHalf} 0;
`;

export const ListItemWrapper = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
